import React, { useEffect, useState } from "react";

// Recorrido guiado de la primera visita: tres globos que senalan las partes principales de la guia. Se puede saltar y no vuelve a aparecer.
const PASOS = [
    { sel: '[data-guia="arbol"]', titulo: "Aquí eliges qué aprender", texto: "El panel de la izquierda tiene los servicios, las rutas de aprendizaje, las arquitecturas de ejemplo, las lecciones para empezar y las prácticas. Puedes buscar por nombre o por lo que quieres lograr." },
    { sel: '[data-guia="simple"], [data-guia="leccion"], [data-guia="diagrama"]', titulo: "Cada idea, con un dibujo animado", texto: "Los puntitos que viajan por las flechas muestran cómo funciona. Puedes pausar, avanzar paso a paso y leer cada explicación." },
    { sel: '[data-guia="falla"]', titulo: "Prueba qué pasa si algo falla", texto: "Este botón apaga una pieza del dibujo para que veas si el resto sigue funcionando. Después toca otra pieza para probar de nuevo." },
];
export const K_RECORRIDO = "guiaAws.recorrido";

const Recorrido = ({ onTerminar }) => {
    const [i, setI] = useState(0);
    const p = PASOS[i];
    useEffect(() => {
        const el = document.querySelector(p.sel);
        if (!el) return undefined;
        el.classList.add("guia-resaltar");
        return () => el.classList.remove("guia-resaltar");
    }, [i]);
    const cerrar = () => { try { localStorage.setItem(K_RECORRIDO, "1"); } catch (e) { /* sin almacenamiento */ } onTerminar(); };
    return (
        <div className="no-imprimir shadow-lg border rounded p-3" role="dialog" aria-label="Recorrido guiado"
            style={{ position: "fixed", right: 20, bottom: 20, width: "min(380px, calc(100vw - 40px))", zIndex: 1055, background: "var(--cui-body-bg, #fff)" }}>
            <div className="small text-muted">Recorrido · {i + 1} de {PASOS.length}</div>
            <div className="fw-bold mb-1">{p.titulo}</div>
            <p className="small mb-2">{p.texto}</p>
            <div className="d-flex justify-content-between">
                <button className="btn btn-link btn-sm text-muted" onClick={cerrar}>Saltar</button>
                {i < PASOS.length - 1 ? <button className="btn btn-primary btn-sm" onClick={() => setI(i + 1)}>Siguiente</button> : <button className="btn btn-success btn-sm" onClick={cerrar}>Entendido</button>}
            </div>
        </div>
    );
};

export default Recorrido;
